<template>
  <div :style="themeStyle">
    <div>
        <v-row class="headline1_bg p-3" no-gutters>
          <v-col cols="12" :style="'color: ' + (isTargetShop ? '#000' : $textcolor)">
            <div @click="$router.go(-1)" :style="isTargetShop ? 'font-size: 20px;' : ''"> <v-icon>mdi-chevron-left</v-icon> {{ isTargetShop?  $t("message.campaign")  : $t("message.promotion") }}</div>
          </v-col>
        </v-row>
        <br>
        <all-promotion levelById="levelById"></all-promotion>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AllPromotion from './AllPromotion'

export default {
  name: 'Reward',
  components: {
    'all-promotion': AllPromotion
  },
  data () {
    return {
      member: null,
      profile: null,
      levelById: null,
      shopId: null
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.shopId = this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID'])
  }
}
</script>
<style scoped>
.headline1_bg {
  background-color: #FFA300 !important;
}
.v-sheet.v-card {
    border-radius: 14px;
    background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Promotion/Promotion.vue